import { Swiper } from "swiper";
import { Navigation, Pagination } from "swiper/modules";

function initReviewCarousels() {
  const containers = document.querySelectorAll<HTMLElement>(
    '[class*="review-carousel-swiper-"]'
  );

  containers.forEach((el) => {
    const match = el.className.match(/review-carousel-swiper-([^\s]+)/);
    const sectionId = match?.[1];
    if (!sectionId) return;

    const prevEl = document.querySelector(
      `.carousel-button-prev-${sectionId}`
    ) as HTMLElement | null;
    const nextEl = document.querySelector(
      `.carousel-button-next-${sectionId}`
    ) as HTMLElement | null;
    const paginationEl = document.querySelector(
      `.carousel-pagination-${sectionId}`
    ) as HTMLElement | null;

    const centeredSlidesMob = el.dataset.centeredMob === "true";
    const centeredSlidesDsk = el.dataset.centeredDsk === "true";

    new Swiper(el, {
      modules: [Navigation, Pagination],
      speed: 300,
      spaceBetween: 24,
      slidesPerView: "auto",
      centeredSlides: centeredSlidesMob,
      loop: centeredSlidesMob,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : undefined,
      pagination:
        paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
      breakpoints: {
        768: {
          centeredSlides: centeredSlidesDsk,
          loop: centeredSlidesDsk,
        },
      },
    });
  });
}

export function init() {
  if (document.readyState === "loading") {
    document.addEventListener("load", initReviewCarousels);
  } else {
    initReviewCarousels();
  }
}
